module.exports = __webpack_public_path__ + "static/media/newmsg.fdf2301f.mp3";